module.exports = __webpack_public_path__ + "static/media/santa Clara.091163e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/santa Clara.jpg
// module id = 435
// module chunks = 0